import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const userId = localStorage.getItem("userId");
  const location = useLocation();

  if (!userId) {
    // If no userId, redirect to landing page ('/') 
    // and replace the history so they can't go 'back' to the black screen
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;